import { KalturaBookmarkFilter } from '../../filters';
import { requestPhoenix } from '../../network';
import { KalturaBookmarkListResponse, KalturaOnDemandResponseProfile } from '../../objects';

export type FetchBookmarkListArgs = {
  filter?: KalturaBookmarkFilter;
  responseProfile?: KalturaOnDemandResponseProfile;
};

/**
 * @see https://latest.api-docs-develop.ott.kaltura.com/api-docs/service/bookmark/action/list
 */
export async function fetchBookmarkList({ filter, responseProfile }: FetchBookmarkListArgs) {
  const response = await requestPhoenix<KalturaBookmarkListResponse>({
    path: '/bookmark/action/list',
    body: { filter, responseProfile },
  });

  return {
    ...response,
    objects: response.objects ?? [],
  };
}
